module.exports = "<div class=\"contArea\">\r\n  <div class=\"titArea\">\r\n    <h3>{{'LANG_SETTING_UserAgreementManagement' | translate}}<em>{{'LANG_NOTICE_UserAgreementManagementDetail' | translate}}</em></h3>\r\n  </div>\r\n  <div class=\"tableTop m_t20\">\r\n    <div class=\"f_left\">\r\n      <a class=\"btnA\" (click)=\"save()\">{{'BUTTON_SAVE_SETTING' | translate}}</a>\r\n    </div>\r\n  </div>\r\n  <div class=\"textAreaBox\">\r\n    <textarea rows=\"20\"  [(ngModel)]=\"content\"></textarea>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/page/system/user_agreement_management.html
// module id = ./src/app/page/system/user_agreement_management.html
// module chunks = main